import styled from "styled-components";

import { FormButton1 } from "../Login/styles";

const RegisterMedia = {
  desktop: "@media(min-width: 768px)",
};

export const ContainerRegister = styled.div`
  @import url("https://fonts.googleapis.com/css2?family=Inter:wght@700&display=swap");
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background: #000000;
  font-family: "Inter" sans-serif;

  header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 300px;
    ${RegisterMedia.desktop} {
      width: 365px;
      img {
        width: 122px;
        height: 17px;
      }
    }
  }
  header button {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0px 17px;
    width: 80px;
    height: 26px;
    background: #212529;
    border: none;
    border-radius: 4px;
    font-style: normal;
    font-weight: 600;
    font-size: 10px;
    line-height: 23px;
    text-align: center;
    color: #f8f9fa;
    cursor: pointer;
    ${RegisterMedia.desktop} {
      width: 90px;
      height: 30px;
      font-size: 12px;
    }
  }

  span {
    color: red;
    font-size: 10px;
    ${RegisterMedia.desktop} {
      font-size: 12px;
    }
  }
`;

export const FormRegister = styled.form`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
  width: 300px;
  height: 630px;
  background: #212529;
  box-shadow: 0px 3.20867px 32.0867px -8.02168px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  font-family: "Inter", sans-serif;
  ${RegisterMedia.desktop} {
    width: 370px;
    height: 700px;
  }

  h1 {
    margin-top: 30px;
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    line-height: 22px;
    color: #f8f9fa;
    ${RegisterMedia.desktop} {
      font-size: 18px;
      line-height: 28px;
      margin-top: 40px;
    }
  }

  input {
    width: 265px;
    height: 40px;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0px 14px;
    background: #343b41;
    border: 0.9px solid #f8f9fa;
    box-sizing: border-box;
    border-radius: 3.5px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: #f8f9fa;
    margin: 10px 0px;
    ${RegisterMedia.desktop} {
      width: 330px;
      height: 48px;
      font-size: 16px;
      line-height: 26px;
    }
  }

  label {
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    line-height: 0px;
    color: #f8f9fa;
    ${RegisterMedia.desktop} {
      font-size: 12px;
    }
  }

  p {
    font-style: normal;
    font-weight: 600;
    font-size: 10px;
    line-height: 14px;
    color: #868e96;
    margin: 15px 0px 17px 0px;
    ${RegisterMedia.desktop} {
      font-size: 12px;
      line-height: 22px;
    }
  }
`;

export const ContainerModules = styled.div`
  width: 260px;
  height: 60px;
  display: flex;
  flex-direction: column;
  ${RegisterMedia.desktop} {
    width: 330px;
    height: 48px;
  }

  label {
    margin-bottom: 20px;
    margin: 10px 0px;
  }
  select {
    width: 260px;
    height: 40px;
    background: #343b41;
    border: 0.9px solid #343b41;
    box-sizing: border-box;
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 21px;
    color: #868e96;
    padding: 0px 5px;
    margin: 10px 0px;
    ${RegisterMedia.desktop} {
      font-size: 16px;
      line-height: 26px;
      width: 330px;
      height: 40px;
    }
  }
`;

export const FormButton3 = styled(FormButton1)`
  background: #59323f;
  border: 1.2px solid #59323f;
  margin-top: 35px;
`;
